import errorBuild from "../assets/vw/svg/error-build.svg";
import successBuild from "../assets/vw/svg/success-build.svg";
import warningBuild from "../assets/vw/svg/warning-build.svg";

export const buildEstado = (estado) => {
  switch (estado) {
    case "SUCCEEDED":
      return successBuild;
    case "FAILED":
      return errorBuild;
    case "IN_PROGRESS":
      return warningBuild;
    default:
      return errorBuild;
  }
};